import React, { useState } from 'react';
import SignInModal from '../components/auth/SignInModal';

/**
 * Test page for authentication components
 * This page demonstrates the SignInModal with email detection
 */
function TestAuthPage() {
  const [showSignIn, setShowSignIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const handleSignInSuccess = (user) => {
    console.log('Sign in successful:', user);
    setCurrentUser(user);
    setShowSignIn(false);
    alert(`Successfully signed in as: ${user.email}`);
  };

  const handleSignOut = () => {
    setCurrentUser(null);
    alert('Signed out successfully');
  };

  const handleSwitchToSignUp = () => {
    alert('Switch to Sign Up modal - This will be implemented in Chunk 2');
    setShowSignIn(false);
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Authentication Test Page</h1>

      <div style={{
        background: '#f5f5f5',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '30px'
      }}>
        <h2>Chunk 1: Email Detection Test</h2>
        <p>This page tests the SignInModal component with real-time email detection.</p>

        <h3>Test Scenarios:</h3>
        <ol>
          <li>
            <strong>New User:</strong> Enter an email that doesn't exist
            <ul>
              <li>System should show "Register" button</li>
              <li>No password field should appear</li>
            </ul>
          </li>
          <li>
            <strong>Existing User:</strong> Enter an existing email
            <ul>
              <li>Password field should appear</li>
              <li>"Forgot Password?" link should show</li>
            </ul>
          </li>
          <li>
            <strong>Username Login:</strong> Enter a username (no @ symbol)
            <ul>
              <li>System should check if username exists</li>
              <li>Show appropriate fields based on result</li>
            </ul>
          </li>
        </ol>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <h3>Current Status:</h3>
        {currentUser ? (
          <div style={{
            background: '#e8f5e9',
            padding: '15px',
            borderRadius: '6px',
            border: '1px solid #4CAF50'
          }}>
            <p><strong>Logged in as:</strong> {currentUser.email}</p>
            <p><strong>User ID:</strong> {currentUser.id}</p>
            <button
              onClick={handleSignOut}
              style={{
                marginTop: '10px',
                padding: '8px 16px',
                background: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Sign Out
            </button>
          </div>
        ) : (
          <div style={{
            background: '#ffebee',
            padding: '15px',
            borderRadius: '6px',
            border: '1px solid #f44336'
          }}>
            <p>Not logged in</p>
          </div>
        )}
      </div>

      <button
        onClick={() => setShowSignIn(true)}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          background: '#4CAF50',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          marginRight: '10px'
        }}
      >
        Open Sign In Modal
      </button>

      <SignInModal
        isOpen={showSignIn}
        onClose={() => setShowSignIn(false)}
        onSuccess={handleSignInSuccess}
        onSwitchToSignUp={handleSwitchToSignUp}
      />

      <div style={{
        marginTop: '40px',
        padding: '20px',
        background: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '6px'
      }}>
        <h3>Backend Changes Made:</h3>
        <ul>
          <li>✅ Created <code>check_user_exists()</code> RPC function</li>
          <li>✅ Created <code>get_email_by_username()</code> RPC function</li>
          <li>✅ Created <code>track_failed_login()</code> RPC function</li>
          <li>✅ Created <code>update_last_login()</code> RPC function</li>
          <li>✅ Added authentication columns to verified_users table</li>
          <li>✅ Implemented account lockout after 5 failed attempts</li>
        </ul>

        <h3>Files Created:</h3>
        <ul>
          <li>✅ <code>src/components/auth/SignInModal.js</code></li>
          <li>✅ <code>src/components/auth/AuthModal.css</code></li>
          <li>✅ <code>src/pages/TestAuthPage.js</code> (this file)</li>
        </ul>
      </div>
    </div>
  );
}

export default TestAuthPage;